// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-pagination{position:static;margin-top:1.25rem}.swiper-pagination .swiper-pagination-bullet{height:10px;width:10px;margin:5px 7px}.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active{background-color:#869791}.carousel-chevron .swiper-button-next,.carousel-chevron .swiper-button-prev{position:static;right:auto;left:auto}.carousel-chevron .swiper-button-next:after,.carousel-chevron .swiper-button-prev:after{content:\"\";display:none}", ""]);
// Exports
module.exports = exports;
